module.exports = "<mat-card class=\"status-text-card\">განხილვაში</mat-card>\n\n<app-admin-grid-item\n  *ngFor=\"let idea of ideas\"\n  [idea]=\"idea\"\n></app-admin-grid-item>\n\n<app-paginator\n  [totalNumberOfRecords]=\"totalIdeas\"\n  (pageEvent)=\"pageEvent($event)\"\n></app-paginator>\n"


//////////////////
// WEBPACK FOOTER
// /opt/app-root/src/src/app/components/admin/components/admin-idea-in-discuss/admin-idea-in-discuss.component.html
// module id = ../../../../../src/app/components/admin/components/admin-idea-in-discuss/admin-idea-in-discuss.component.html
// module chunks = main